import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye_open",
  "use": "icon-eye_open-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol viewBox=\"0 0 20 12\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye_open\">\r\n<path d=\"M10 1C6.2 1 3.3 2.6 1.2 6C3.3 9.4 6.2 11 10 11C13.8 11 16.7 9.4 18.8 6C16.7 2.6 13.8 1 10 1ZM10 12C5.7 12 2.3 10 0 6C2.3 2 5.7 0 10 0C14.3 0 17.7 2 20 6C17.7 10 14.3 12 10 12ZM10 8C11.1 8 12 7.1 12 6C12 4.9 11.1 4 10 4C8.9 4 8 4.9 8 6C8 7.1 8.9 8 10 8ZM10 9C8.3 9 7 7.7 7 6C7 4.3 8.3 3 10 3C11.7 3 13 4.3 13 6C13 7.7 11.7 9 10 9Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol